import { Pipe, PipeTransform } from '@angular/core';
import { Permission, PermissionSubject } from '../../classes';

@Pipe({ name: 'filterSubjects', pure: false })
export class FilterSubjectPipe implements PipeTransform {
  transform(subjects: PermissionSubject[], permissions: Permission[]): any {
    return subjects.filter(item => !permissions.find(permission => permission.name === item.name));
  }
}
